<script>
import moment from '@phoenix/moment';

export default {
  props: {
    openingExceptions: {
      type: Object,
      required: true,
    },
  },

  computed: {
    textHoursExceptions() {
      const exceptions = this.openingExceptions?.textHoursExceptions;
      if (!exceptions) {
        return [];
      }

      return exceptions.filter((exception) => this.isRangeOutOfBounds(exception.startDate, exception.endDate));
    },

    hoursExceptions() {
      const exceptions = this.openingExceptions?.hoursExceptions;
      if (!exceptions) {
        return [];
      }

      return exceptions
        .filter((exception) => this.isRangeOutOfBounds(exception.date, exception.endDate))
        .map((exception) => ({
          ...exception,
          date: moment(exception.date).format('l'),
          endDate: moment(exception.endDate).format('l'),
        }));
    },
  },

  methods: {
    isRangeOutOfBounds(startDate, endDate) {
      const dateNow = moment().startOf('day');
      const start = moment(startDate).format('YYYY-MM-DD');
      const end = moment(endDate).format('YYYY-MM-DD');
      return dateNow.isBetween(start, end, undefined, '[]');
    },
  },
};
</script>

<template>
  <div v-if="hoursExceptions.length > 0 || textHoursExceptions.length > 0" class="boutique-page__schedule-exceptions">
    <template v-if="hoursExceptions.length > 0" class="boutique-page__schedule-exceptions">
      <h4 class="h6 boutique-page__schedule-title">{{ $t('store.exceptionalClosing') }}</h4>
      <dl class="boutique-page__schedule">
        <template v-for="exception in hoursExceptions" :key="exception.date">
          <dt>{{ `${exception.date} - ${exception.endDate}` }}</dt>
          <dd>{{ $t('store.closed') }}</dd>
        </template>
      </dl>
    </template>

    <template v-if="textHoursExceptions.length > 0" class="boutique-page__schedule-exceptions">
      <template v-for="exception in textHoursExceptions" :key="exception.title">
        <h4 class="h6 boutique-page__schedule-title">
          {{ exception.title }}
        </h4>
        <p class="boutique-page__schedule" style="text-transform: none" v-html="exception.description"></p>
      </template>
    </template>
  </div>
</template>
